<template lang="html">
  <div class="not-found">
    <b-img src="static/img/nowhere.jpg" fluid alt="Page not found"></b-img>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue